import type { MiniAppRoute } from "../api/types.js";
import { messages } from "../i18n/messages.js";
import { NavIcon } from "./ui/NavIcons.js";

interface BottomNavProps {
  active: MiniAppRoute;
  onNavigate: (route: MiniAppRoute) => void;
  cartCount?: number;
}

const NAV_ITEMS: Array<{ id: Exclude<MiniAppRoute, "manager" | "all_categories">; label: string }> = [
  { id: "home", label: messages.nav.home },
  { id: "catalog", label: messages.nav.catalog },
  { id: "cart", label: messages.nav.cart },
  { id: "profile", label: messages.nav.profile },
];

export function BottomNav({ active, onNavigate, cartCount = 0 }: BottomNavProps) {
  return (
    <nav
      className="fixed bottom-0 left-1/2 z-30 w-full max-w-[520px] -translate-x-1/2 border-t border-black/10 bg-[var(--tg-theme-bg-color,#ffffff)]/95 backdrop-blur supports-[backdrop-filter]:bg-[var(--tg-theme-bg-color,#ffffff)]/85"
      aria-label={messages.nav.home}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <ul className="grid grid-cols-4">
        {NAV_ITEMS.map((item) => {
          const isActive = active === item.id;
          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onNavigate(item.id)}
                className={`relative flex min-h-[56px] w-full flex-col items-center justify-center gap-1 px-2 py-2 text-[11px] transition ${
                  isActive ? "font-semibold text-[var(--tg-theme-button-color,#3390ec)]" : "opacity-70"
                }`}
                aria-current={isActive ? "page" : undefined}
              >
                <NavIcon route={item.id} active={isActive} />
                <span>{item.label}</span>
                {item.id === "cart" && cartCount > 0 ? (
                  <span className="absolute right-4 top-1 min-h-4 min-w-4 rounded-full bg-[var(--tg-theme-button-color,#3390ec)] px-1 text-[10px] leading-4 text-[var(--tg-theme-button-text-color,#fff)]">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                ) : null}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
